import React, { ReactElement } from 'react'

import { useAppDispatch, useAppSelector } from 'src/store/hooks'
import {
  assignInstructors,
  updateInstructorAssignment,
  fetchEventCompliances,
  fetchAvailableInstructors,
  createInstructor,
  updateInstructor,
  selectAvailableInstructors,
  selectAvailableInstructorsStatus,
  selectInstructorsStatusByEventID,
} from 'src/v3/content-pipeline/event-pipeline.slice'
import { ContentComplianceStatus, Instructor } from 'src/v3/core/types'
import InstructorsManagement from 'src/v3/content-pipeline/components/instructors-management'

type InstructorManagementProps = {
  eventID: string
  instructors?: Instructor[]
  complianceStatus?: ContentComplianceStatus
  onUpdate?: () => void
}

export default function InstructorManagement({
  eventID,
  instructors = [],
  complianceStatus,
  onUpdate,
}: InstructorManagementProps): ReactElement {
  let dispatch = useAppDispatch()
  let availableInstructors = useAppSelector(selectAvailableInstructors)
  let availableInstructorsStatus = useAppSelector(
    selectAvailableInstructorsStatus,
  )
  let saveStatus = useAppSelector(selectInstructorsStatusByEventID(eventID))
  let hasAssignedInstructors = instructors.length > 0

  return (
    <InstructorsManagement
      droppableId={`event-${eventID}-instructors`}
      instructors={instructors}
      complianceStatus={complianceStatus}
      availableInstructors={availableInstructors}
      availableInstructorsStatus={availableInstructorsStatus}
      saveStatus={saveStatus}
      onFetchAvailableInstructors={() => dispatch(fetchAvailableInstructors())}
      onSave={(instructorIds) => {
        let instructorData = { eventID, instructors: instructorIds }
        dispatch(
          hasAssignedInstructors
            ? updateInstructorAssignment(instructorData)
            : assignInstructors(instructorData),
        )
      }}
      onSaved={() => {
        dispatch(fetchEventCompliances())
        if (onUpdate) onUpdate()
      }}
      onCreateInstructor={async (payload) => {
        // eslint-disable-next-line no-restricted-syntax -- TODO(ENG-694): pre-existing await dispatch/.unwrap() pattern; refactor to selector-driven state
        let result = await dispatch(createInstructor(payload))
        if (!createInstructor.fulfilled.match(result)) {
          return Promise.reject(new Error('Failed to create instructor'))
        }
        return result.payload
      }}
      onUpdateInstructor={async (instructorId, payload) => {
        // eslint-disable-next-line no-restricted-syntax -- TODO(ENG-694): pre-existing await dispatch/.unwrap() pattern; refactor to selector-driven state
        let result = await dispatch(updateInstructor({ instructorId, payload }))
        if (!updateInstructor.fulfilled.match(result)) {
          return Promise.reject(new Error('Failed to update instructor'))
        }
        return result.payload
      }}
    />
  )
}
